import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-312f78e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary me-3",
  "data-bs-toggle": "modal",
  "data-bs-target": "#inviteUserModal"
}, " Invite ", -1))
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "table"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Created At")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, [
      /*#__PURE__*/_createElementVNode("b", null, "Actions")
    ])
  ])
], -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_DeleteUserModal = _resolveComponent("DeleteUserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, [
        _createTextVNode(" Users "),
        _createVNode(_component_router_link, { to: "/settings/user-invite" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.loading ? "Loading" : ""), 1))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(["", { odd: index }]),
                        key: item.name
                      }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.userEmail), 1),
                          (item.type == 'OWNER')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (OWNER)"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.format(item.createdAt)), 1),
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_feather_icon, {
                            type: "trash-2",
                            class: "cursor-pointer me-3",
                            size: "18",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deleteUserModal",
                            onClick: ($event: any) => (_ctx.selectedEmail = item.userEmail)
                          }, null, 8, ["onClick"])
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_DeleteUserModal, {
      onReload: _ctx.load,
      userEmail: _ctx.selectedEmail
    }, null, 8, ["onReload", "userEmail"])
  ], 64))
}